import Vue from "vue";
import Pageable from "@/entities/pageable/pageable_collection";
import { RawServicePoint, RawServicePointType, ServicePoint, ServicepointType } from "@/entities";
import { BACKEND_BASE_URL, BACKEND_BASE_URL_READS, ResponseCreate, ResponseCreateV2 } from "../backend.types";
import { ServicePointService } from "@/services";
import { RawPage } from "@/entities/pageable/pageable_types";
import { DeviceV2 } from "@/entities/device";

export class ServicePointServiceImpl implements ServicePointService {
  async fetchServicePoints(map: Record<string, unknown>): Promise<Pageable<ServicePoint>> {
    const { data } = await Vue.$axios.post<RawPage<RawServicePoint>>(
      `${BACKEND_BASE_URL_READS}/api/v2/servicepoints`,
      map
    );
    if (!data.results && data.servicepoints) {
      data.results = data.servicepoints;
    }
    return {
      totalResult: data.totalResult,
      results: data.results?.map((rawServicePoint) => new ServicePoint(rawServicePoint)) ?? [],
    };
  }

  async fetchServicePointsByGroupRules(groupId: string, map: Record<string, unknown>): Promise<Pageable<ServicePoint>> {
    const { data } = await Vue.$axios.post<RawPage<RawServicePoint>>(
      `${BACKEND_BASE_URL_READS}/api/v1/group/${groupId}/rules/servicepoints`,
      map
    );
    if (!data.results && data.projections) {
      data.results = data.projections;
    }
    return {
      totalResult: data.totalResult,
      results: data.results?.map((rawServicePoint) => new ServicePoint(rawServicePoint)) ?? [],
    };
  }

  async createServicePointV3(servicePoint: ServicePoint): Promise<ResponseCreateV2> {
    const { data } = await Vue.$axios.post<ResponseCreateV2>(`${BACKEND_BASE_URL}/service/v3/servicepoint`, {
      entityCode: servicePoint.entity?.code,
      centerCode: servicePoint.center?.code,
      deviceCode: servicePoint.device?.code,
      name: servicePoint.name,
      code: servicePoint.code,
      countryCode: servicePoint.center?.countryCode,
      clientMode: servicePoint.device?.clientMode,
    });

    return data;
  }

  async updateServicePointV3(servicePoint: ServicePoint): Promise<void> {
    console.log("updateServicePoint " + JSON.stringify(servicePoint));
    const { data } = await Vue.$axios.put<any>(`${BACKEND_BASE_URL}/api/v3/servicepoint/${servicePoint.id}`, {
      name: servicePoint.name,
      isActive: true,
    });
    return data;
  }
  async changeStatus(servicePoint: ServicePoint): Promise<void> {
    await Vue.$axios.put<void>(`${BACKEND_BASE_URL}/api/v3/servicepoint/${servicePoint.id}`, {
      name: servicePoint.name,
      isActive: servicePoint.active,
    });
  }
  async fetchServicePointTypes(): Promise<ServicepointType[]> {
    const { data } = await Vue.$axios.get<{ servicePointTypes: RawServicePointType[] }>(
      `${BACKEND_BASE_URL_READS}/api/v1/servicepointtypes`
    );
    return data.servicePointTypes.map((v) => new ServicepointType(v));
  }
}
